import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AnalyticsService } from '@app/src/app/minimal/services/Analytics';

@Component({
  selector: 'mg-tt-root',
  templateUrl: './tt-root.component.html',
  styleUrls: ['./tt-root.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TtRootComponent {
  constructor(private _analytics: AnalyticsService) {
    this._analytics.logEvent('teacherToolsOpened', {});
  }
}
